<template>
    <div>
        <b-modal v-model="showDetails" :size="size" :title="title">
            <div class="row">
                <div class="col col-12">
                    <span class="texto-modal">{{ texto }}</span>
                </div>
            </div>

            <template v-slot:modal-footer>
                <div class="row">
                    <b-btn-group class="mr-2">
                        <b-btn block variant="default" @click="closeDetails">Fechar</b-btn>
                    </b-btn-group>
                </div>
            </template>
        </b-modal>
    </div>
</template>

<script>
export default {
  props: {
    title: { default: "detalhes", type: String },
    size: { default: "lg", type: String }
  },
  data () {
    return {
      showDetails: false,
      texto: ""
    }
  },
  methods: {
    closeDetails () {
      this.showDetails = false
    },
    openModal (data) {
      let th = this;
      th.showDetails = true;
      th.texto = data;
    }
  }
}
</script>

<style scoped>
    .texto-modal {
        white-space: pre-wrap;
        line-height: 25px;
        word-wrap: break-word;
    }
</style>
